<script setup lang="ts">
/**
 * 等级 as a badge, LV1 to LV100 (utils/lvBadge.ts draws it): beside a
 * customer's name in both consoles, over 经验's progress in 账户中心. The
 * markup is built from the level number alone, so v-html is safe here.
 * Shared byte-identical by both consoles.
 */
import { computed } from 'vue'
import { lvBadgeSvg } from '@/utils/lvBadge'

const props = withDefaults(defineProps<{ lv: number; scale?: number }>(), { scale: 1 })
// Gradient ids are page-wide: each badge its own.
const prefix = `lvb${Math.random().toString(36).slice(2, 9)}`
const svg = computed(() => lvBadgeSvg(props.lv, props.scale, prefix))
</script>

<template>
  <span class="lv-badge" :aria-label="`LV${lv}`" role="img" v-html="svg" />
</template>

<style scoped>
.lv-badge {
  display: inline-flex;
  flex: none;
  align-items: center;
  line-height: 0;
}
</style>

<style>
/* The dark theme, and where 双色模式 darkens the navbar or the menu: each
   band's lighter end, which every badge carries as --lvb-*-dark. */
body[arco-theme='dark'] .lv-badge svg,
.tone-dark .lv-badge svg {
  --lvb-ink: var(--lvb-ink-dark);
  --lvb-s0: var(--lvb-s0-dark);
  --lvb-s1: var(--lvb-s1-dark);
}
</style>
